import styled, { css } from 'styled-components'
import AppButton from 'Components/AppButton'
import CompareCta from 'Components/CompareCta'
import PlaceHolder from 'Components/PlaceHolder'
import AppLinkMobileCtrl from 'Components/AppLinkMobileCtrl'

import {
  TEXT_GREY,
  FONT_BASE_COLOR,
  LINK_COLOR,
  OUTLINE_COLOR,
  LIKE_BTN_COLOR,
  CLICKABLE_COLOR,
  SELECTED_ITEM_BG_COLOR,
  TOP_NAV_BGCOLOR,
} from '@CSSVars/colors'
import { BREAK_POINT_MD, BREAK_POINT_LG } from '@CSSVars/variables'

export const _ListingTopBanner = styled.div`
  width: calc(100% - 128px);
  max-width: 1140px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  position: relative;
  z-index: 1000;
  background-color: white;

  padding: 16px 0;
  @media screen and (max-width: 1023px) {
    width: 100%;
    padding-right: 12px;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: flex;
    min-height: 70px;
    height: auto;
    padding: 12px 12px 12px 0;
  }
  ${({ isMobileApp }) =>
    (isMobileApp
      ? `
      position: fixed;
      top: 0;
      left: 0;
      padding: 12px;
      min-height: 70px;
      height: auto;
      display: flex;
    `
      : '')};
`

export const _LeftBlock = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;

  max-width: calc(100% - 90px);
`
const titleMixin = css`
  padding: 0;
  font-family: var(--secondary-font);
  font-size: 16px;
  font-weight: 600;
  line-height: 19.5px;
  color: ${FONT_BASE_COLOR};
  text-transform: capitalize;
  pointer-events: visible;
  margin-bottom: 8px;

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 2px;
  }
`

export const _AddressContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  height: 100%;
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    margin-left: ${({ showBackBtn }) => (showBackBtn ? '8px' : '24px')};
  }
`

export const _Title = styled.h1`
  ${titleMixin};
`

export const _PlaceholderTitle = styled(PlaceHolder)`
  ${titleMixin};
  height: 24px;
  width: 250px;
  margin-bottom: 22px !important;
`

const addressMixin = css`
  max-width: 100%;
  font-family: var(--secondary-font);

  a {
    text-decoration: underline;
  }

  h2,
  span,
  a {
    color: ${TEXT_GREY};
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    flex-grow: 0;
    max-width: 100%;
    font-size: 14px;
    line-height: 17px;

    @media screen and (max-width: ${BREAK_POINT_LG}) {
      font-size: 12px;
      line-height: 22px;
    }
  }

  @media (hover: hover) {
    a:hover {
      color: ${OUTLINE_COLOR};
    }
  }
  a:active {
    color: ${FONT_BASE_COLOR};
  }
`
export const _Address = styled.div`
  ${addressMixin};
  width: 100%;
`

export const _BuildingLink = styled(AppLinkMobileCtrl)`
  pointer-events: visible;
  color: ${CLICKABLE_COLOR}!important;
  font-weight: 600 !important;

  flex-shrink: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (hover: hover) {
    &:hover {
      color: ${LINK_COLOR} !important;
    }
  }
  &:active {
    color: ${SELECTED_ITEM_BG_COLOR} !important;
  }

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    font-weight: 500;
  }
`

export const _AddressInlineLink = styled(AppLinkMobileCtrl)`
  ${addressMixin};
  display: inline-block;
  ~ span {
    display: inline-block;
    text-decoration: none;
  }

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: none !important;
    ~ span {
      display: none;
    }
    &:last-child {
      display: inline-block !important;
    }
  }
`

export const _AddressInlineSpan = styled.span`
  ${addressMixin};
  display: inline-block;
  ~ span {
    display: inline-block;
  }

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: none !important;
    ~ span {
      display: none;
    }
    &:last-child {
      display: inline-block !important;
    }
  }
`

export const _BackBtn = styled.div`
  svg {
    fill: ${LINK_COLOR};
  }
`
export const _BackBtnContainer = styled.div`
  width: 44px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
`
export const _RightBlock = styled.div`
  display: ${({ isAddressPage }) => (isAddressPage ? 'none' : 'flex')};
  flex-direction: row;

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    margin-right: 0px;
  }
`

export const _CompareCta = styled(CompareCta)`
  height: 44px !important;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid ${OUTLINE_COLOR};
  margin-right: 4px;
  display: flex;
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    display: none;
  }
  @media (hover: hover) {
    :hover {
      font-weight: 500;
    }
  }
`
export const _Buttons = styled.div`
  display: flex;
  flex-direction: row;
  height: auto;
  align-items: start;
`

const iconBoxMixin = css`
  margin: 0 4px;
  padding: 0 8px !important;
  height: 44px;
  border: 1px solid ${OUTLINE_COLOR};
  border-radius: 10px;
  span {
    margin: 0 8px;
    font-size: 14px;
    line-height: 22px;
    font-weight: 500;
  }

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    border: none;

    svg {
      height: 22px !important;
      width: 20px !important;
      padding: 0;
    }

    span {
      display: none;
    }
  }
`

export const _FavButton = styled(AppButton)`
  ${iconBoxMixin};
  span {
    color: ${LIKE_BTN_COLOR};
  }
  .favouriteSt2 {
    fill: ${LIKE_BTN_COLOR};
  }
  span {
    color: ${LIKE_BTN_COLOR};
  }
  ${({ active }) =>
    (active
      ? `
          .st6 {
            fill: ${LIKE_BTN_COLOR};
            stroke: ${LIKE_BTN_COLOR};
          }
        `
      : `
          .st6 {
            fill: white;
            stroke: white;
          }
        `)}
  &:active {
    background-color: ${SELECTED_ITEM_BG_COLOR};
    .favouriteSt2 {
      fill: ${({ active }) => (active ? 'white' : SELECTED_ITEM_BG_COLOR)};
    }
    .st6 {
      stroke: ${({ active }) => (active ? 'white' : SELECTED_ITEM_BG_COLOR)};
    }
  }
`
export const _ShareButton = styled(AppButton)`
  ${iconBoxMixin};
  .shareSt2 {
    fill: ${TOP_NAV_BGCOLOR};
  }
  span {
    color: ${TOP_NAV_BGCOLOR};
  }
  &:active {
    background-color: ${SELECTED_ITEM_BG_COLOR};
    .shareSt2 {
      fill: white !important;
    }
  }
`
